import xhttp from 'src/utils/xhttp'

const formview = {
    /**
     * 视图列表
     *
     * @param {string} webappId
     * @param {string} keyword
     * @param {number} page
     * @param {number} pageSize
     */
    getViewList(params) {
        return xhttp.get('/api/dev/form-view', { params })
    },

    /**
     * 添加视图
     *
     * @param {string} name
     * @param {string} webappId
     * @param {string} engineVersion
     * @param {string} remark
     * @param          API 相关字段
     */
    addView(params) {
        return xhttp.post('/api/dev/form-view', params)
    },

    copyView(params) {
        return xhttp.post(`/api/dev/form-view/${params.formViewId}/copy`, params)
    },

    /**
     * 删除视图
     *
     * @param {string} viewId
     */
    deleteView(viewId) {
        return xhttp.delete(`/api/dev/form-view/${viewId}`)
    },

    /**
     * 视图详情
     *
     * @param {string} id
     */
    getViewDetail(id) {
        return xhttp.get(`/api/dev/form-view/${id}`)
    },

    /**
     * 更新视图
     *
     * @param {string} formViewId
     * @param {string} name
     * @param {string} webappId
     * @param {string} remark
     * @param          API 相关字段
     */
    updateView(params) {
        return xhttp.put(`/api/dev/form-view/${params.formViewId}`, params)
    },

    /**
     * 获取 API 列表
     *
     * @param {string} webappId
     */
    getAPIList(webappId) {
        return xhttp.get('/api/dev/form-view/api/list', { params: { webappId } })
    },

    /**
     * 获取 API 数据
     *
     * @param {string} url
     * @param {string} env
     * @param {string} webappId
     * @param {string} params
     */
    getAPIData(params) {
        return xhttp.post('/api/dev/form-view/open-data-api', params)
    },

    /**
     * 获取表单子组件列表
     *
     * @param {string} engineVersion
     */
    getFormComponents(engineVersion) {
        return xhttp.get(`/api/dev/form-view/components/${engineVersion}`)
    }
}

export default formview
